import { render, staticRenderFns } from "./CollectionDetailTabBasic.vue?vue&type=template&id=4ba724d8&"
import script from "./CollectionDetailTabBasic.vue?vue&type=script&lang=ts&"
export * from "./CollectionDetailTabBasic.vue?vue&type=script&lang=ts&"
import style0 from "./CollectionDetailTabBasic.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
